export default "/_next/static/data/hero-animation.json-8b2397b3ffc00f7cffd1c1a9f9df0444.json";